import { Mail, Phone, MapPin, BookOpen } from "lucide-react";
import { useSearchParams } from "react-router-dom";
import { useLang } from "../context/LanguageContext";
import QuoteForm from "../components/QuoteForm";

export default function Quote() {
  const { t } = useLang();
  const [searchParams] = useSearchParams();
  const cataloguePage = searchParams.get("page");
  const fromCatalogue = searchParams.get("from") === "catalogue";

  return (
    <div data-testid="quote-page" className="bg-white">
      <section className="pgb-container pt-20 md:pt-28 pb-8">
        <span className="eyebrow">{t.quotePage.eyebrow}</span>
        <h1 className="mt-4 text-4xl md:text-6xl font-black tracking-tighter text-[#0B1B29] max-w-3xl">
          {t.quotePage.title}
        </h1>
        <p className="mt-6 text-[#536878] leading-relaxed max-w-2xl">
          {t.quotePage.subtitle}
        </p>

        {fromCatalogue && cataloguePage && (
          <div
            className="mt-8 inline-flex items-start gap-4 bg-[#0B1B29] text-white p-5 max-w-2xl"
            data-testid="quote-catalogue-context"
          >
            <div className="bg-white shrink-0">
              <img
                src={`/catalogue/thumbs/p-${String(cataloguePage).padStart(3, "0")}.jpg`}
                alt={`Catalogue page ${cataloguePage}`}
                className="h-24 w-auto block"
              />
            </div>
            <div>
              <span className="eyebrow text-[#F59E0B] flex items-center gap-2">
                <BookOpen size={13} /> {t.common.catalogue.eyebrow}
              </span>
              <p className="mt-2 text-sm text-white leading-relaxed">
                Enquiring about <strong className="text-[#F59E0B]">{t.common.catalogue.page} {cataloguePage}</strong> — we've pre-filled your message below. Feel free to edit.
              </p>
            </div>
          </div>
        )}
      </section>

      <section className="pgb-container pb-24 md:pb-32 grid grid-cols-1 lg:grid-cols-12 gap-10">
        <aside className="lg:col-span-4 order-2 lg:order-1">
          <div className="bg-[#0B1B29] text-white p-8 md:p-10 space-y-6">
            <div>
              <span className="eyebrow text-[#93C5FD]">{t.footer.contact}</span>
              <p className="mt-3 text-white/80 leading-relaxed text-sm">
                {t.footer.tagline.en}
              </p>
            </div>
            <div className="h-px bg-white/10" />
            <div className="flex items-start gap-3 text-sm">
              <Mail size={16} className="text-[#93C5FD] mt-0.5" />
              <div>
                <div className="text-xs uppercase tracking-[0.18em] text-white/50">{t.footer.emailLabel}</div>
                <div className="mt-1 text-white">{t.footer.email}</div>
              </div>
            </div>
            <div className="flex items-start gap-3 text-sm">
              <Phone size={16} className="text-[#93C5FD] mt-0.5" />
              <div>
                <div className="text-xs uppercase tracking-[0.18em] text-white/50">{t.footer.phoneLabel}</div>
                <div className="mt-1 text-white">{t.footer.phone}</div>
              </div>
            </div>
            <div className="flex items-start gap-3 text-sm">
              <MapPin size={16} className="text-[#93C5FD] mt-0.5" />
              <div>
                <div className="text-xs uppercase tracking-[0.18em] text-white/50">Address</div>
                <div className="mt-1 text-white/85 leading-relaxed">
                  Foshan / Guangzhou, China<br />
                  Baku, Azerbaijan
                </div>
              </div>
            </div>
          </div>
        </aside>

        <div className="lg:col-span-8 order-1 lg:order-2">
          <QuoteForm />
        </div>
      </section>
    </div>
  );
}
